var config = {};

config.currentCountry = process.env.REACT_APP_COUNTRY;
config.isTest = process.env.REACT_APP_TEST === "true";
config.skipCache = process.env.REACT_APP_SKIP_CACHE === "true";
config.version = "1.0.6.9";
config.currentState = "";

export default config;
